import { cloneElement, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Drawer from "@mui/material/Drawer";
import { MenuOutlined, Close } from "@mui/icons-material";
import "./Header.css";

const NAV_ITEMS = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Faculty", path: "/faculty" },
  { name: "Research", path: "/research" },
  { name: "Cases", path: "/cases" },
  { name: "Events", path: "/events" },
  { name: "Contact", path: "/contact" },
];

function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });
  return cloneElement(children, { elevation: trigger ? 4 : 0 });
}

// A section stays highlighted on its sub-pages too (e.g. /research/<article>).
const isActivePath = (pathname, path) => (path === "/" ? pathname === "/" : pathname === path || pathname.startsWith(`${path}/`));

const Header = (props) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const drawerContent = (
    <div className="drawer-container">
      <div className="drawer-header">
        <div
          className="drawer-logo-block"
          onClick={() => {
            navigate("/");
            handleDrawerToggle();
          }}>
          <img src="/logo.png" alt="SGPGI Logo" className="drawer-logo-img" />
          <div>
            <div className="drawer-logo-title">SGPGI</div>
            <div className="drawer-logo-sub">Pediatric Surgical Superspecialties</div>
          </div>
        </div>
        <Close onClick={handleDrawerToggle} className="close-icon" />
      </div>
      <div className="drawer-nav-list">
        {NAV_ITEMS.map((item) => (
          <div
            key={item.name}
            className={`drawer-item ${isActivePath(location.pathname, item.path) ? "active" : ""}`}
            onClick={() => {
              navigate(item.path);
              handleDrawerToggle();
            }}>
            {item.name}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <ElevationScroll {...props}>
        <AppBar position="fixed" className="gov-appbar">
          {/* ── Top banner ── */}
          <div className="gov-header-top">
            <div className="gov-header-top-inner">
              {/* Left: logo + titles */}
              <Link to="/" className="gov-brand">
                <img src="/logo.png" alt="SGPGI Logo" className="gov-brand-logo" />
                <div className="gov-brand-divider" />
                <div className="gov-brand-text">
                  <div className="gov-brand-hindi">एस.जी.पी.जी.आई. बाल शल्य चिकित्सा अतिविशेषज्ञता</div>
                  <div className="gov-brand-english">SGPGI Pediatric Surgical Superspecialties</div>
                  <div className="gov-brand-full">
                    Sanjay Gandhi Postgraduate Institute of Medical Sciences, Lucknow
                  </div>
                </div>
              </Link>

              {/* Right: accreditation image */}
              <div className="gov-brand-right">
                <img src="/pgi.png" alt="SGPGI" className="gov-accred-img" />
              </div>
            </div>
          </div>

          {/* ── Nav bar ── */}
          <div className="gov-navbar">
            <div className="gov-navbar-inner">
              <div className="gov-nav-desktop">
                {NAV_ITEMS.map((item) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    className={`gov-nav-item ${isActivePath(location.pathname, item.path) ? "gov-nav-active" : ""}`}>
                    {item.name.toUpperCase()}
                  </Link>
                ))}
              </div>
              <div className="gov-mobile-menu-icon" onClick={handleDrawerToggle}>
                <MenuOutlined style={{ color: "#fff", fontSize: "26px" }} />
              </div>
            </div>
          </div>
        </AppBar>
      </ElevationScroll>

      <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle} ModalProps={{ keepMounted: true }}>
        {drawerContent}
      </Drawer>

      <div className="gov-header-spacer" />
    </>
  );
};

export default Header;
